import { Box, Flex } from '@chakra-ui/react';
import { ReviewCard } from './ReviewCard';
import { REVIEWS } from './constants';

export const ReviewsCarousel = () => {
  return (
    <Box>
      <Flex flexDir={'row'} overflow={'scroll'} gap={5} pb={3} px={2}>
        {REVIEWS.map(({ content, name, stars }, i) => (
          <ReviewCard key={i} content={content} name={name} numStars={stars} />
        ))}
      </Flex>
    </Box>
  );
};
